import { MilestoneEntries } from '@/store/milestones/types';
import { Select, SelectItem, type SharedSelection } from '@heroui/react';
import type { ReactNode } from 'react';
import { StandardIcon } from '../icon';
import { MilestoneItem } from '../output/milestone';

export function MilestoneSelect({
  label,
  value,
  onChange,
  className,
  startContent,
  placeholder,
}: {
  label?: string;
  value?: string;
  onChange?: (value?: string) => void;
  className?: string;
  startContent?: ReactNode;
  placeholder?: string;
}) {
  const selectedKeys = value ? [value] : [];

  function changeHandler(keys: SharedSelection) {
    const values = Array.from(keys);
    onChange?.(values.length ? (values[0] as string) : undefined);
  }

  return (
    <>
      <Select
        label={label}
        aria-label={label || 'Milestone'}
        selectedKeys={selectedKeys}
        onSelectionChange={changeHandler}
        className={className}
        startContent={startContent}
        placeholder={placeholder}
        items={MilestoneEntries}
        renderValue={(items) =>
          items
            .filter((item) => item.data?.id)
            .map((item) => (
              <MilestoneItem id={item.data!.id} key={item.data!.id} />
            ))
        }
      >
        {(item) => (
          <SelectItem key={item.id} textValue={item.label}>
            <div className='flex h-5 flex-row items-center'>
              <StandardIcon id={item.icon} className='mr-2' />
              <span>{item.label}</span>
            </div>
          </SelectItem>
        )}
      </Select>
    </>
  );
}
